/**
 * @generated SignedSource<<cdc6592d7d27e892fa2481cb1400be11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReactionViewerGroups$data = {
  readonly reactionGroups: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ReactionButton_Reaction" | "ReactionsMenuItem_Reaction">;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"addReactionMutation_ReactionGroups">;
  readonly " $fragmentType": "ReactionViewerGroups";
};
export type ReactionViewerGroups$key = {
  readonly " $data"?: ReactionViewerGroups$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReactionViewerGroups">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReactionViewerGroups",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionGroup",
      "kind": "LinkedField",
      "name": "reactionGroups",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReactionButton_Reaction"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReactionsMenuItem_Reaction"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "addReactionMutation_ReactionGroups"
    }
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
};

(node as any).hash = "36f140444d097083055d0b01339e4a5c";

export default node;
